import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateWorkspaceRewardThresholds } from "api/services/workspace-service";
import { IUpdateRewardThresholdsRequest } from "api/models/request/IUpdateRewardThresholdsRequest";
import { WORKSPACE_REWARD_THRESHOLDS_QUERY_KEY } from "hooks/rewardThresholds/queryKeys";

export const useUpdateWorkspaceRewardThresholds = (workspaceId: string) => {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (request: IUpdateRewardThresholdsRequest): Promise<IUpdateRewardThresholdsRequest> => {
            const response = await updateWorkspaceRewardThresholds(workspaceId, request);
            if (!response.success) {
                throw new Error("rewardThresholds.saveError");
            }

            return request;
        },
        onSuccess: (request) => {
            queryClient.setQueryData([...WORKSPACE_REWARD_THRESHOLDS_QUERY_KEY, workspaceId], request);
        },
    });

    return {
        updateRewardThresholds: mutation.mutate,
        updatingRewardThresholds: mutation.isPending,
    };
};
